/* src/app/modules/login/user-login/user-login.page.scss */
:host ::ng-deep ng-otp-input .ng-otp-input-wrapper {
  display: flex;
  justify-content: center;
  gap: 10px;
}
:host ::ng-deep ng-otp-input .otp-input {
  width: 46px !important;
  height: 52px !important;
  text-align: center;
  border-radius: 14px !important;
  border: 2px solid var(--ion-color-primary-shade) !important;
  font-size: 22px !important;
  font-weight: 700 !important;
  color: var(--ion-color-secondary-shade) !important;
  background: var(--ion-color-secondary) !important;
  transition: border-color 0.2s ease, box-shadow 0.2s ease !important;
}
:host ::ng-deep ng-otp-input .otp-input:focus {
  border-color: var(--ion-color-secondary-shade) !important;
  box-shadow: 0 0 0 3px rgba(32, 59, 114, 0.14) !important;
  outline: none !important;
}
.login-wrapper {
  min-height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px 20px 36px;
  gap: 0;
}
.login-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 26px;
}
.brand-logo-wrap {
  width: 180px;
  max-width: 72vw;
}
.brand-logo {
  width: 100%;
  height: auto;
  display: block;
}
.brand-tagline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--ion-color-secondary-shade);
  font-size: 12.5px;
  font-weight: 500;
  letter-spacing: 0.4px;
}
.brand-tagline ion-icon {
  font-size: 15px;
  color: var(--ion-color-dark);
}
.login-card {
  width: 100%;
  max-width: 460px;
  background: var(--ion-color-secondary);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 28px;
  padding: 28px 24px 26px;
  box-shadow: 0 28px 64px rgba(0, 0, 0, 0.38), 0 4px 14px rgba(0, 0, 0, 0.16);
  position: relative;
}
.modal-close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.08);
  color: var(--ion-color-medium);
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.modal-close-btn ion-icon {
  font-size: 20px;
}
.modal-close-btn:hover {
  background: rgba(0, 0, 0, 0.15);
  color: var(--ion-color-dark);
}
.step-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 28px;
}
.step-icon-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  border-radius: 18px;
  background: var(--ion-color-primary-tint);
  border: 1px solid var(--ion-color-light-tint);
  flex-shrink: 0;
}
.step-icon-box ion-icon {
  font-size: 26px;
  color: var(--ion-color-secondary-shade);
}
.step-icon-box.otp-step {
  background:
    linear-gradient(
      135deg,
      var(--ion-color-primary-tint),
      #cfe8f5);
}
.step-kicker {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--ion-color-primary);
}
.step-kicker ion-icon {
  font-size: 13px;
}
.step-title {
  margin: 5px 0 6px;
  font-size: 19px;
  font-weight: 700;
  color: var(--ion-color-secondary-shade);
  line-height: 1.25;
}
.step-subtitle {
  margin: 0;
  font-size: 13.5px;
  color: var(--ion-color-primary-contrast);
  line-height: 1.55;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}
.step-subtitle ion-icon {
  font-size: 14px;
  color: var(--ion-color-secondary-shade);
  flex-shrink: 0;
}
.step-subtitle strong {
  color: var(--ion-color-secondary-shade);
  font-weight: 600;
}
.login-form {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.field-block {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.field-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--ion-color-secondary-shade);
  cursor: default;
}
.field-label ion-icon {
  font-size: 16px;
  color: var(--ion-color-secondary-shade);
}
.login-field {
  width: 100%;
  margin: 0;
}
.phone-prefix {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--ion-color-secondary-shade);
  font-weight: 600;
  font-size: 14px;
}
.phone-prefix ion-icon {
  font-size: 14px;
  vertical-align: middle;
}
mat-error {
  font-size: 12px;
}
.agent-switch-btn {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  margin-top: 6px;
  padding: 13px 16px;
  border: 1.5px dashed var(--ion-color-light-tint);
  border-radius: 14px;
  background: transparent;
  color: var(--ion-color-secondary-shade);
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.agent-switch-btn ion-icon {
  font-size: 19px;
  color: var(--ion-color-secondary-shade);
  flex-shrink: 0;
}
.agent-switch-btn .switch-chevron {
  margin-left: auto;
  font-size: 16px;
  color: var(--ion-color-primary-contrast);
  transition: transform 0.2s ease;
}
.agent-switch-btn:hover {
  background: var(--ion-color-primary-tint);
  border-color: var(--ion-color-secondary-shade);
  border-style: solid;
}
.agent-switch-btn:hover .switch-chevron {
  transform: translateX(3px);
}
.form-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 18px;
}
.signup-nudge {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  font-size: 13px;
  color: var(--ion-color-primary-contrast);
}
.signup-nudge ion-icon {
  font-size: 15px;
  color: var(--ion-color-medium);
}
.signup-nudge span {
  color: var(--ion-color-primary-contrast);
}
.text-link-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: none;
  padding: 0;
  color: var(--ion-color-primary);
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: text-decoration-color 0.2s ease;
}
.text-link-btn ion-icon {
  font-size: 14px;
}
.text-link-btn:hover {
  text-decoration-color: var(--ion-color-primary);
}
.outline-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 12px 18px;
  border: 1.5px solid var(--ion-color-light-tint);
  border-radius: 14px;
  background: transparent;
  color: var(--ion-color-secondary-shade);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.outline-action-btn ion-icon {
  font-size: 17px;
}
.outline-action-btn:hover {
  background: var(--ion-color-primary-tint);
  border-color: var(--ion-color-secondary-shade);
}
.primary-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 13px 24px;
  border: none;
  border-radius: 14px;
  background:
    linear-gradient(
      135deg,
      var(--ion-color-secondary-shade) 0%,
      #2a4d96 100%);
  color: #ffffff;
  font-size: 14.5px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(32, 59, 114, 0.32);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  flex-shrink: 0;
}
.primary-action-btn ion-icon {
  font-size: 18px;
}
.primary-action-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(32, 59, 114, 0.42);
}
.primary-action-btn:disabled {
  opacity: 0.48;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.otp-body {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.otp-input-row {
  display: flex;
  justify-content: center;
  padding: 6px 0 4px;
}
.otp-error-msg {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 11px 16px;
  border-radius: 12px;
  background: rgba(240, 65, 65, 0.08);
  border: 1px solid rgba(240, 65, 65, 0.22);
  color: var(--ion-color-danger);
  font-size: 13.5px;
  font-weight: 500;
}
.otp-error-msg ion-icon {
  font-size: 18px;
  flex-shrink: 0;
}
.otp-resend-row {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 13px;
  color: var(--ion-color-primary-contrast);
}
.otp-resend-row ion-icon {
  font-size: 15px;
  color: var(--ion-color-medium);
}
.otp-timer {
  color: var(--ion-color-dark);
  font-size: 13px;
  font-weight: 600;
}
.login-security-note {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 22px;
  color: var(--ion-color-secondary-shade);
  font-size: 12px;
  font-weight: 500;
}
.login-security-note ion-icon {
  font-size: 14px;
  color: var(--ion-color-secondary-shade);
}
mat-form-field {
  width: 100%;
}
h1,
h2 {
  margin: 0;
}
/*# sourceMappingURL=user-login.page.css.map */
